import { Component, ElementRef, Input, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ModuleInfoService } from '../orgbrain-dialogs/services/module-info.service';

@Component({
  selector: 'orgbrain-super-info-box',
  templateUrl: './super-info-box.component.html',
  styleUrls: ['./super-info-box.component.scss'],
    standalone: false
})
export class SuperInfoBoxComponent {
  @ViewChild('infodialog', { static: true }) infodialog: TemplateRef<any>;
  @ViewChild('button', { static: true }) button: ElementRef<any>;

  @Input() set text(v: string) {
    this._text = v;
    this._text_width = 40 + this.getTextWidth(this._text) + 24;
    console.log(this._text_width);
  }
  @Input() positionBelow = false;

  _text = 'Placeholder infobox tooltip';
  _text_width;
  isExpanded = false;

  toggleExpand() {
    this.isExpanded = !this.isExpanded;
  }

  getTextWidth(text, fontSize = '14px', fontFace = 'Roboto') {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    context.font = `${fontSize} ${fontFace}`;
    const metrics = context.measureText(text);
    return metrics.width;
  }
}
